import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoundService {

  private audio!: HTMLAudioElement;
  constructor() { 
    this.audio = new Audio()
		this.audio.src = 'sounds/alert.wav'
		this.audio.load()
  }

  play() {
    this.audio.play()
  }
}
